import type { LandingPageCardData } from '@/app/components/LandingPage/LandingPageCards/types';

export const cards: LandingPageCardData[] = [
  {
    description: {
      messageKey: 'business_cards_athletics_description',
    },
    id: 'business_cards_athletics',
    image: {
      localizedAlt: 'business_image_gym_alt',
      src: '/blue-sky/oura-for-business/business-athletics-hd.png',
    },
    title: {
      messageKey: 'business_cards_athletics_title',
    },
  },
  {
    description: {
      messageKey: 'business_cards_business_sales_description',
    },
    id: 'business_cards_business_sales',
    image: {
      localizedAlt: 'business_image_sales_meeting_alt',
      src: '/blue-sky/oura-for-business/business-business-sales-hd.png',
    },
    title: {
      messageKey: 'business_cards_business_sales_title',
    },
  },
  {
    description: {
      messageKey: 'business_cards_government_description',
    },
    id: 'business_cards_government',
    image: {
      localizedAlt: 'business_image_government_alt',
      src: '/blue-sky/oura-for-business/business-government-hd.png',
    },
    title: {
      messageKey: 'business_cards_government_title',
    },
  },
  {
    description: {
      messageKey: 'business_cards_health_care_description',
    },
    id: 'business_cards_health_care',
    image: {
      localizedAlt: 'business_image_doctor_alt',
      src: '/blue-sky/oura-for-business/business-health-care-hd.png',
    },
    title: {
      messageKey: 'business_cards_health_care_title',
    },
  },
];
